export const getBeneficiaryExportData = (attention) => {
  const hasBeneficiary = Boolean(attention.affiliateFullName?.trim());
  const fullName = hasBeneficiary ?
    attention.affiliateFullName :
    attention.accountFullName;
  const document = hasBeneficiary ?
    attention.affiliateDocument :
    attention.accountDocument;

  return {
    fullName: fullName ?? '',
    document: document ?? '',
  };
};

const formatAmount = (amount) => {
  if (amount === undefined || amount === null || amount === '') {
    return '';
  }

  if (typeof amount === 'number') {
    return amount.toLocaleString('es-ES', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }

  return amount;
};

const getHeaderToValueMap = () => ({
  ID_ATENCIÓN: 'attentionId',
  ID_SERVICIO_MEDICO: 'medicalServiceId',
  ID_SEDE_PRESTADOR: 'branchId',
  ID_SEDE: 'branchId',
  ID_AFILIADO: 'affiliateId',
  MODALIDAD: 'modality',
  MONTO_NETO: (item) => formatAmount(item.netAmount),
  MONTO_PAGADO: (item) => formatAmount(item.amountPaid),
  OBSERVACIONES: 'observations',
  FECHA_DE_CREACIÓN: (item) => item.createdDate?.slice(0, 10) ?? '',
  FECHA_CREACIÓN: (item) => item.createdDate?.slice(0, 10) ?? '',
  COPAGO: (item) => formatAmount(item.copago),
  PROTOCOLO: 'protocolCode',
  NOMBRE: 'name',
  NOMBRE_SERVICIO: 'name',
  NOMBRE_COMPLETO_AFILIADO: (item) =>
    getBeneficiaryExportData(item).fullName,
  DOCUMENTO_AFILIADO: (item) =>
    getBeneficiaryExportData(item).document,
  NÚMERO_AFILIADO: 'affiliateNumber',
  NOMBRE_SERVICIO_MEDICO: 'medicalServiceName',
  DESCRIPCIÓN_SERVICIO_MEDICO: 'medicalServiceDescription',
  DESCRIPCIÓN_PRESTACIÓN: 'medicalServiceDescription',
  CÓDIGO_SERVICIO_MEDICO: 'medicalServiceCode',
  CODIGO_PRESTACIÓN: 'medicalServiceCode',
  CATEGORÍA_SERVICIO_MEDICO: '', // No data source currently
  DÍAS_A_PAGAR: '', // No data source currently
  NOMBRE_PLAN: 'planName',
  SEDE: 'branchAddress',
  DIRECCIÓN_SEDE: 'branchAddress',
  NOMBRE_SEDE: 'branchAddress',
  NOMBRE_PRESTADOR: 'providerName',
  CREDENCIALES: '', // No data source
  NÚMEROS: '', // No data source
  NOMBRE_AFILIADO: (item) =>
    getBeneficiaryExportData(item).fullName,
  CREADA_POR: 'createdBy',
  FORMA_DE_PAGO: 'paymentMethod',
  TIPO_DE_FORMA_DE_PAGO: 'paymentMethodType',
  NÚMERO_FACTURA: 'invoiceNumber',
});

export const getAttentionHistoryExportRows = (attentions, headers) => {
  const headerToValueMap = getHeaderToValueMap();

  return attentions.map((item) => {
    const row = {};

    headers.forEach((header) => {
      const keyOrFn = headerToValueMap[header];

      if (typeof keyOrFn === 'function') {
        row[header] = keyOrFn(item);
      } else if (typeof keyOrFn === 'string' && keyOrFn in item) {
        row[header] = item[keyOrFn] ?? '';
      } else {
        row[header] = '';
      }
    });

    return row;
  });
};
